import { Drug } from "domain/entities/drug";
import { Result } from "domain/entities/result";
import { DrugRepository } from "domain/repositories";

export default class UpdateUseCase {
    private drugRepository: DrugRepository;
    
    public constructor(drugRepository: DrugRepository) {
        this.drugRepository = drugRepository
    }

    public async updateDrug(id: number, drug: Drug, token: Promise<[string | null, string | null]>): Promise<[Result, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.drugRepository.updateDrug(id, drug, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}